export class Action {
    nom_action !: string;
}

export class Intervenant {
    id_personne !: number;
	intervenant !: string; 
}

export class Suivi {
    
	id_sav_suivi !: number;
	id_machine_suivie !: number;
	id_appelant !: number;
	nom_appelant !: string;
	numero_serie !: string;
	date_debut !: string;
	facturable !: number;
	termine !: number;
	brouillon !: number;
	duree !: number;
	nom_installation !: string;
	id_installation !: number;
	intervenants !: Intervenant[];
	actions !: Action[];
	state? : CallGmao;
}

export class Call {
    suivis !: Suivi[];
}

export class CallGmao {
	call_state ! :boolean;
	state_time !: string;
	user_login !: number;
	call_id !: number;
	new : boolean = true;
}

export class CallsCount {
	sav_suivis_count !: number;
}

export class CallStat {
	DEBUT !: string;
	NUMERO !: string;
	HOTLINER !: string;
	ACTION !: string;
	CONTRAT!: string;
	ID_SAV_SUIVI! : number;
	DUREE! : number;
	DEPT! :string;
	call_state!: boolean;
	state_time!: string;
	superviseur!: string;
}

export class ContractType{
	ID_CONTRAT_SAV!: number;
	NOM_CONTRAT!: string;
}

export class CallBreakdown {
	NOM !: string;
	NB !: number;
}

export class Breakdown{
	code!: string;
	pannes!: string[];
}

export class CallBreakdownDetails{
	date!: string;
	pannes!: Breakdown;
}

export class CodePanne{
	code!: string;
	nom!: string;
	cat_id?: number;
	panne_id?: number;
}

export class TechnicienSav {
	ID_PERSONNE !: number;
	NOM !: string;
	PRENOM !: string;
}

export class ListInstallationsMESAndInstallees {
	numero_serie !: string; 
	nom_installation !: string;
	raison_sociale !: string;
	statut !: number;
	date_installation !: string; 
	date_MES !: string;
	date_arret !: string;
	code_EBP !: string; 
	code_postal !: string;
}

export class Personne{
	id_personne !: number;
	civilite !: string;
	prenom_nom !: string;
}

export class Tab{
	id_suivi !: number;
	title !: string;
	mode !: string
}
